/** Versions du moteur, figées avec chaque simulation enregistrée. */
export const ENGINE_MMI_2026 = 'mmi-2026';
export const ENGINE_MMI_2026_CORRECTED = 'mmi-2026-corrected';
//# sourceMappingURL=engine.js.map